<div class="quill-editor">
    <div #editor></div>
</div>
